import { useEffect } from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import s from './CenterModal.module.css';

export default function CenterModal({ isOpen, onClose, children, maxWidth = 945 }) {
  const isDesktop = useMediaQuery('(min-width: 1200px)');

  useEffect(() => {
    if (!isOpen || !isDesktop) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [isOpen, isDesktop]);

  useEffect(() => {
    if (!isOpen || !isDesktop) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, isDesktop, onClose]);

  if (!isOpen || !isDesktop) return null;

  return (
    <>
      <div className={s.scrim} onClick={onClose} aria-hidden="true" />
      <div
        className={s.panel}
        role="dialog"
        aria-modal="true"
        style={{ maxWidth: `${maxWidth}px` }}
      >
        {children}
      </div>
    </>
  );
}
